export enum SIGNUP_STEP {
	FORM,
	LOGO,
	PAYMENT,
	INFO,
}
